import { createFileRoute } from '@tanstack/react-router';

import { LibraryPage } from '@/features/library';
import { librarySearchSchema } from '@/features/library/searchParams';

export const Route = createFileRoute('/workspaces/$workspaceId/library')({
  // Which tab is open, what was searched, and which item's drawer is open are
  // all shareable and survive a reload (spec 104 FR-005, spec 108 FR-001), so
  // they live in the address rather than in state.
  validateSearch: librarySearchSchema,
  component: LibraryRoute,
});

export function LibraryRoute() {
  const { workspaceId } = Route.useParams();
  const { tab, q, state, item } = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <LibraryPage
      workspaceId={workspaceId}
      tab={tab}
      q={q}
      state={state}
      item={item}
      onTabChange={(nextTab) =>
        void navigate({ search: (prev) => ({ ...prev, tab: nextTab }) })
      }
      // A narrowing is a place the reader chose to be, so Back widens again.
      // Typing is not: the search replaces, as it already did, or Back would
      // walk the reader through every keystroke.
      onStateChange={(nextState) =>
        void navigate({ search: (prev) => ({ ...prev, state: nextState }) })
      }
      onSearchChange={(nextQ) =>
        void navigate({
          search: (prev) => ({ ...prev, q: nextQ }),
          replace: true,
        })
      }
      // An open drawer is a place, so it pushes: Back after closing reopens it,
      // and Back after opening closes it (spec 108 contract).
      onItemChange={(nextItem) =>
        void navigate({ search: (prev) => ({ ...prev, item: nextItem }) })
      }
    />
  );
}
